import { AssetService } from '@schenck/rotec-components';
import { AssetType } from '../types/asset-types';
import { Injectable, inject } from '@angular/core';
@Injectable()
export class AssetTypeService {
  public assetService = inject(AssetService);

  getAssetType(assetId: string): AssetType {
    if (this.assetService.plants.some((value) => value.id === assetId)) {
      return 'plant';
    } else if (this.assetService.machineGroups.some((value) => value.id === assetId)) {
      return 'group';
    } else if (this.assetService.machines.some((value) => value.id === assetId)) {
      return 'machine';
    } else {
      return 'machine';
    }
  }
}
